export const ADDRESSES = {
    "PAIR_LOGIC": {
        "137": "0xE70654a42310B34bef95ad034f21665B71Df9768",
        "690": "0xe01a2B06DAd328C60019F6bBAD8717F0633d1b06",
        "8453": "0xc73Cd0402dD3243b244a676d77838fC82Ae2E79F",
        "84532": "0x8f9e51abA099BaAbBd5c5F4315028B57615f2b2b"
    },
    "PROXY_ADMIN": {
        "137": "0x21b4191Be2d854f2ac4350d49F1c4FC2110f532D",
        "690": "0xbE06391E5534619360C037e3457E7243BC2fF45B",
        "8453": "0x177e977cDd1Bc8c753d18a602F82FC83577b6847",
        "84532": "0xc256F32C08FaF19354C94B56E2aaacc27f421902"
    },
    "BANK": {
        "137": "0x45e8548166147545C709b9A55E60029f3E31FCeF",
        "690": "0x0Ff9a6f8250b8946cb7d98EefED9D62DC07D9C36",
        "8453": "0x5600177Be4d20C7AcF19D0B91451DB29a18d8f3f",
        "84532": "0x743B59cbCb0acB3Ac48ff4Cdf23679203bD9B63D"
    },
    "EXCHANGE": {
        "137": "0xbC9fe6c6C5729f76799E3eF8726194BD5E917968",
        "690": "0x3363C202577f4605f188Cc0de2B707f73f2E4C17",
        "8453": "0x38Bb26d391B9496D9614456efe9700D1dAdd0ff5",
        "84532": "0x1C7B37ec7f8fA1276445266C4eDb2ba5435eB905"
    },
    "BTLY": {
        "84532": "0xF1CF8c98Cd12A21f1ebD2373C88DB182d63C6d71"
    },
    "USDC": {
        "84532": "0x4fe853163A95AC410D388234B87E387352d26B08"
    }
};
export const STABLE_COINS = {
    "84532": ['0x4fe853163A95AC410D388234B87E387352d26B08'],
    "690": ['0xD5d59fC063e7548b6015A36fEb10B875924A19be'],
    "8453": [
        '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
        '0x820c137fa70c8691f0e44dc420a5e53c168921dc',
        '0x50c5725949a6f0c72e6c4a641f24049a917db0cb',
    ],
    "137": [
        '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359',
        '0x2791bca1f2de4661ed88a30c99a7a9449aa84174',
        '0xc2132d05d31c914a87c6611c10748aeb04b58e8f',
    ],
};
export const RATES_ENDPOINTS = {
    "84532": 2,
    "690": 2,
    "8453": 2,
    "137": 2,
};
export const TOKEN_BRIDGES = {
    84532: {
        "0x4fe853163A95AC410D388234B87E387352d26B08": "https://faucet.bitly.exchange"
    },
    690: {
        "0x4200000000000000000000000000000000000006": "https://redstone.xyz/bridge",
        "0xD5d59fC063e7548b6015A36fEb10B875924A19be": "https://redstone.xyz/bridge",
    },
};
// Number.MAX_SAFE_INTEGER means no limit
export const BATCH_BLOCK_SIZE = {
    "84532": 10000,
    "690": Number.MAX_SAFE_INTEGER,
    "8453": Number.MAX_SAFE_INTEGER,
    "137": Number.MAX_SAFE_INTEGER,
};
